import styled from 'styled-components'

export const LoadingStyled = styled.div`
  height: 30px;
  width: 30px;
  margin: 10px auto;
  border-radius: 50%;
  border-top: 4px solid #99175c;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #99175c;
  border-left: 4px solid #99175c;
  animation: spin 800ms linear infinite;

  @media (max-width: 1500px) {
    height: 28px;
    width: 28px;
  }

  @media (max-width: 1300px) {
    height: 24px;
    width: 24px;
    border-top: 2px solid #99175c;
    border-right: 2px solid transparent;
    border-bottom: 2px solid #99175c;
    border-left: 2px solid #99175c;
  }

  @media (max-width: 1100px) {
    height: 20px;
    width: 20px;
    border-top: 2px solid #99175c;
    border-right: 2px solid transparent;
    border-bottom: 2px solid #99175c;
    border-left: 2px solid #99175c;
  }
`
